export default __webpack_public_path__ + "static/media/school.b1ca1b3a.png";